import { CardLinkDto} from "@dtos/card-link.dto";
import { CardLink } from "@models/card-link.model";
import { BaseConverter } from "./BaseConverter";
import { CardInfoTranslationConverter } from "./cardInfoTranslationConverter";

export class CardLinkConverter extends BaseConverter<CardLink, CardLinkDto>{
   
    private cardInfoConverter = new CardInfoTranslationConverter()

    modelToDto(model: CardLink): CardLinkDto {
        return new CardLinkDto(
            model.id,
            model.displaySorting,
            model.recommended,
            model.link,
            model.photo,
            model.cardInfo ? this.cardInfoConverter.modelToDto(model.cardInfo) : undefined,  
        )
    }

    dtoToModel(dto: CardLinkDto): CardLink {
        return new CardLink(
            dto.id,
            dto.displaySorting,
            dto.recommended,
            dto.link,
            dto.photo,
            dto.cardInfo ? this.cardInfoConverter.dtoToModel(dto.cardInfo) : undefined
        )
    }
}